<template>
  <v-layout class="user" align-center @click="handleShowUser">
    <v-avatar size="40" class="ma-2">
      <template v-if="value.profile_pic == null">
        <img src="/static/img/assets/livechat/profile.png" />
      </template>
      <img v-else :src="value.profile_pic" @error="onFailLoad" />
    </v-avatar>
    <v-flex class="pa-2">
      <div
        v-if="$store.state.rabbitPage.includes(selectedBot.pageid)"
        class="text-truncate"
        style="max-width: 228px"
      >
        {{ userRealname }}
      </div>
      <div v-else class="text-truncate" style="max-width: 228px">
        {{ value.first_name }} {{ value.last_name }}
      </div>
      <div class="caption grey--text">
        <ChannelLabel :channel="value.app">
          <template #channel="{ channelColor, selectedChannel }">
            <span v-if="selectedChannel" :style="{ color: channelColor }">
              <em v-if="selectedChannel.icon" :class="selectedChannel.icon" />
              {{ selectedChannel.text }}
            </span>
          </template>
        </ChannelLabel>
      </div>
      <div class="caption grey--text">
        {{ value.subject }}
      </div>
    </v-flex>
    <v-flex shrink class="text-xs-right">
      <v-btn icon color="primary" @click.stop="$emit('goToLivechat', value)">
        <v-icon small>chat</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import ChannelLabel from '@/components/elements/ChannelLabel'

export default {
  components: {
    ChannelLabel
  },
  props: ['value', 'funnel'],
  data: function () {
    return {
      showUser: false,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    userRealname: {
      get() {
        if (this.value && this.value.realname) {
          return this.value.realname
        } else
          return (
            (this.value.first_name ? this.value.first_name : '') +
            (this.value.last_name ? ' ' + this.value.last_name : '')
          )
      }
    }
  },
  methods: {
    handleShowUser() {
      this.$store.state.funnel.currentUser = this.value
      this.$store.state.funnel.showUser = true
    },
    async onEditTicket(ticket) {
      var response = await this.getTicketById(ticket.id)
      if (response.data && response.data.length > 0) this.$emit('onChangeUser', response.data[0])
      this.showUser = false
    },
    getTicketById(id) {
      var data = {
        id: id,
        pageid: this.selectedBot.pageid
      }
      return new Promise((resolve, reject) => {
        api.getTicketById(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
    getTimeFormat: function (date1, date2) {
      if (date1.diff(date2, 'days') > 0) {
        return date1.diff(date2, 'days') + ' วัน'
      } else if (date1.diff(date2, 'hours') > 0) {
        return date1.diff(date2, 'hours') + ' ชม'
      } else if (date1.diff(date2, 'minutes') > 0) {
        return date1.diff(date2, 'minutes') + ' นาที'
      } else if (date1.diff(date2, 'seconds') > 0) {
        return date1.diff(date2, 'seconds') + ' วินาที'
      }
    },
    onFailLoad: function (event) {
      // eslint-disable-next-line no-undef
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    goToLivechat: function () {
      console.log(this.value.context == 'contactadmin')
      console.log(this.value.context)
      let routeData = this.$router.resolve({
        name: 'livechat',
        path: '/' + this.currentLang + '/livechat',
        query: {
          userid: this.value.userid,
          user: this.value.context == 'contactadmin' ? 'admin' : 'bot',
          app: this.value.app
        }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.user {
  cursor: pointer;
  &:hover {
    background: #eee;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/FunnelUser.vue